import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=07c59e50&scoped=true"
import script from "./BankSetting.vue?vue&type=script&lang=js"
export * from "./BankSetting.vue?vue&type=script&lang=js"
import style0 from "./BankSetting.vue?vue&type=style&index=0&id=07c59e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c59e50",
  null
  
)

export default component.exports